import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header'; 
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Howitworks from './pages/Howitworks';
import Contact from './pages/Contact';
import Booking from './pages/Booking';
import Profile from './pages/Profile';


import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import './App.css';

// ഹെഡറും ഫൂട്ടറും കാണിക്കണോ എന്ന് തീരുമാനിക്കുന്ന സബ്-കോംപോണന്റ്
function AppContent() {
  const location = useLocation();
  
  // ലോഗിൻ പേജും (/admin-login) ഡാഷ്ബോർഡും (/admin/dashboard) ഒരേപോലെ ഒഴിവാക്കാൻ
  const isAdminPage = location.pathname.startsWith('/admin');

  return (
    <div className="App">
      {/* അഡ്മിൻ പേജ് അല്ലെങ്കിൽ മാത്രം ഹെഡർ കാണിക്കുക */}
      {!isAdminPage && <Header />}

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/howitworks" element={<Howitworks />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
      </main>

      {/* അഡ്മിൻ പേജ് അല്ലെങ്കിൽ മാത്രം ഫൂട്ടർ കാണിക്കുക */}
      {!isAdminPage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;